import { type FC } from 'react';

import { BaseIcon, type BaseIconOuterProps } from '@/components/common/icons/BaseIcon';

export const ChevronDownIcon: FC<BaseIconOuterProps> = (props) => {
  return (
    <BaseIcon iconType="stroke" {...props}>
      <path d="M6 9L12 15L18 9" />
    </BaseIcon>
  );
};
